<div
  class="flex w-full"
  [ngClass]="{
    'justify-end': alineamiento == 'der',
    'justify-start': alineamiento == 'izq',
    'justify-center': alineamiento == 'cen'
  }"
>
  <button
    pRipple
    class="flex flex-row justify-around transition-all duration-200 items-center shadow-md"
    (click)="onClick()"
    [disabled]="desactivado"
    [ngClass]="{
      'bg-primary-400': desactivado && color == 'primary',
      'bg-secondary-100': desactivado && color == 'secondary',
      'bg-tertiary-100': desactivado && color == 'tertiary',
      'bg-red-500-100': desactivado && color == 'transparent',
      'cursor-not-allowed': desactivado,
      'rounded-full': rounded,
      'rounded-md': !rounded,
      'px-4 py-1': !rounded,
      'p-2': rounded,
      'bg-[#2c63aa]': color == 'primary',
      'bg-secondary-600': color == 'secondary',
      'bg-tertiary-600': color == 'tertiary',
      'bg-transparent': color == 'transparent',
      'bg-yellow-400': color == 'warning',
      'bg-[#add8e6]': color == 'lightblue',
      'bg-green-500': color == 'green-600',
      'bg-red-500': color == 'red-600',
      'bg-red-900': color == 'red-900',
      'bg-[#F0F0F0]': color == 'gray',
      'border-b-2': borderBottom,
      'border': borderBottom,
      'border-solid': borderBottom,
      'border-[#e1e1e1]': borderBottom,
    }"
  >
    @if(icon) {
    <img src="assets/svg/{{ icon }}" alt="Icon" width="13" class="blanco mr-1" />
    } @if(!rounded) {
    <p
      class="text-white font-bold p-1"
      [ngClass]="{
        'pr-2': (primeIcon || icon) && !rounded,
        'text-white': colorTexto == 'white',
        'text-black': colorTexto == 'black',
        }"
    >
      {{ texto }}
    </p>
    } @if(primeIcon) {
    <i
      class="pi {{ primeIcon }} text-white"
      style="font-size: {{ !small ? '2rem' : '1rem' }}"
    ></i>
    }
  </button>
</div>
